var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"temFoot"},[_vm._v(" \n  东莞市灵猴智能科技有限公司 Copyright © 2019-2020 All Rights Reserved 版权所有\n  "),_c('a',{attrs:{"target":"_blank","href":"http://beian.miit.gov.cn"}},[_vm._v("粤ICP备19001243号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f4c0ff4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/public/foot.vue
// module id = null
// module chunks = 